// extracted by mini-css-extract-plugin
export default {"gauge":"ZD8boZYfHoN_1d5t6sfa"};